module.exports = __webpack_public_path__ + "static/media/why-chart-mobile2.dfcc3af0.png";